import {
  Flex,
  FormConfigurationProvider, LinkButton, ModelCheckbox,
  useModelFormUpdate,
} from '@equifinance/shared';
import { formatDateTime } from '@equifinance/shared/utils';
import styled from 'styled-components';
import {
  Divider, InfoPanel, SubmitContainer, SubmittedText,
} from '../../components/UnderwriterDecision';
import {
  useChecklistContext,
} from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';
import { usePageConfigurationContext } from '../../../../contexts/pageConfiguration';
import TitleSection from './Sections/TitleSection';
import { PlusIcon } from '../../../Account/components/Icons';
import OS1OS3UnderwriterDecision from './Sections/OS1OS3UnderwriterDecision';

export const OS1OS3RefName = 'OS1OS3';

const ButtonContainer = styled.div`
  width: fit-content;
`;

const AddTitleControls = styled(Flex)`
  justify-content: end;
`;
const AddTitleLinkBtn = styled(LinkButton)`${({ theme }) => `
  font-weight: ${theme.fontWeight.bold};
  font-size: ${theme.fontSize[2]};
  color: ${theme.colours.link[1]};
`}`;

const AddIcon = styled(PlusIcon)`${({ theme }) => `
  color: ${theme.colours.link[1]};
`}`;

export default function OS1OS3Section() {
  const { checklist } = useChecklistContext();
  const { os1os3, errors, warnings } = checklist ?? {};
  const {
    titles, checklistIndicatorType, submitted, submittedByName, submittedTimestamp, canSubmit,
  } = os1os3 ?? {};

  const { isReadOnly: isPageReadOnly } = usePageConfigurationContext();
  const isSectionDisabled = submitted || checklistIndicatorType === 'Locked' || isPageReadOnly;
  const update = useModelFormUpdate();

  const onAddNewTitle = () => {
    if (isSectionDisabled) return;
    update({ 'os1os3.titles': [...(titles ?? []), {}] });
  };

  return (
    <PaddedGenericSection
      refName={OS1OS3RefName}
      section={ChecklistSection.OS1_OS3}
      subSection={ChecklistSection.NOTES_OS1_OS3}
      checklistItem={os1os3}
      errors={errors}
      warnings={warnings}
    >

      <FormConfigurationProvider isReadOnlyInput={isSectionDisabled}>
        <AddTitleControls>
          <AddTitleLinkBtn
            onClick={onAddNewTitle}
          >
            <AddIcon />
            {' '}
            Add Title
          </AddTitleLinkBtn>
        </AddTitleControls>

        {titles?.map((title, index) => (
          <TitleSection key={title.id} title={title} index={index} numOfTitles={titles?.length ?? 0} />
        ))}

        <OS1OS3UnderwriterDecision />
      </FormConfigurationProvider>

      <SubmitContainer>
        {submitted && submittedByName && submittedTimestamp && (
          <InfoPanel>
            <SubmittedText>
              {submittedByName}
            </SubmittedText>
            <Divider />
            <SubmittedText>
              {formatDateTime(submittedTimestamp, 'DD/MM/YYYY, HH:mm:ss')}
            </SubmittedText>
          </InfoPanel>
        )}
        <ButtonContainer>
          <ModelCheckbox
            label="Mark as complete"
            field="os1os3.submitted"
            disabled={!canSubmit || checklistIndicatorType === 'Locked'}
            successColor={submitted}
            isCompleteCheckbox
          />
        </ButtonContainer>
      </SubmitContainer>
    </PaddedGenericSection>
  );
}
